import { User } from './../model/user.model';
import { AuthenService } from './../services/authen.service';
import { Injectable, Inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import swal from 'sweetalert2';
import { JwtHelperService } from "@auth0/angular-jwt";
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private CountTime: number = 0;
  private RefershTokenTime_Secound = (3600 * 6);
  constructor(private _authService: AuthenService, @Inject('BASE_URL') private baseUrl: string, private spinnerService: Ng4LoadingSpinnerService,) {
    this.baseUrl = baseUrl
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add authorization header with basic auth credentials if available
    let currentUser: User = JSON.parse(localStorage.getItem('currentUser'));
    if (!request.url.includes(this.baseUrl)) //other api
      return next.handle(request);
    var x = ["/api/authentication/login", '/api/authentication/verify'];
    for (let index = 0; index < x.length; index++) {
      const element = x[index];
      if (request.url.includes(element))
        return next.handle(request);
    }
    if (currentUser && currentUser.token) {

      const helper = new JwtHelperService();
      const decodedToken = helper.decodeToken(currentUser.token);
      const expirationDate = helper.getTokenExpirationDate(currentUser.token);
      const isExpired = helper.isTokenExpired(currentUser.token);
      if (isExpired) {
        this.spinnerService.hide();
        swal({
          title: 'เกิดข้อผิดพลาด!',
          // text: msgError,
          html: "Session ของคุณหมดอายุ กรุณา Login อีกครั้ง",
          type: 'error',
          confirmButtonText: 'ปิด',
          allowOutsideClick: true
        }).then(c => {
          this._authService.logout();
        });
      }
      else {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${currentUser.token}`
          }
        });
        return next.handle(request);
      }
    }
    else {
      this.spinnerService.hide();
      swal({
        title: 'เกิดข้อผิดพลาด!',
        // text: msgError,
        html: "Your token is invalid or has expired. Please login again",
        type: 'error',
        confirmButtonText: 'ปิด',
        allowOutsideClick: true
      }).then(c => {
        this._authService.logout();
      });
    }

  }
}
